
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForward10s as ObiForward10sElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-forward-10s.js';
 
 
 

 
 export const ObiForward10s = createComponent({
   react: React,
   tagName: 'obi-forward-10s',
   elementClass: ObiForward10sElement,
   events: {
     
   }
  });
 
 